// extracted by mini-css-extract-plugin
module.exports = {"buttons":"DocumentsStyles_buttons__2MoKg","button":"DocumentsStyles_button__2zXNp","document":"DocumentsStyles_document__2ZviD"};